var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC4riklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Hover---Kasutaja",
    transform: "translate(-934.000000, -33.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(936.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    points: "4.48 14.2933333 0 16 1.70666667 11.52 8.67111111 4.59111111 11.4088889 7.32888889"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9377778,4.83555556 L11.1644444,2.06222222 L12.6577778,0.568888889 C13.4044444,-0.177777778 14.6488889,-0.177777778 15.4311111,0.568888889 L15.4311111,0.568888889 C16.1777778,1.31555556 16.1777778,2.56000036 15.4311111,3.34222222 L13.9377778,4.83555556 Z",
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/Icon_Pencil.5905f185b71301597f8d48188cf881f3.svg";
export { ForwardRef as ReactComponent };